import { createEffect, createStore, createEvent } from 'effector';

import type { GetAvailableTehzorResponse } from './ticket-tehzor.types';

export const fxGetAvailableTehzor = createEffect<number, GetAvailableTehzorResponse, Error>();
export const fxSendTicketToTehzor = createEffect<number, any, Error>();

export const sendTicketToTehzor = createEvent<void>();

export const $isAvailableTehzor = createStore<boolean>(false);
export const $isSendedToTehzor = createStore<boolean>(false);
